// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Tesamorelin Refill (systemic) 09.17.26" (ad3e35b5-09d3-437b-8856-3a56e84ece3e). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiTesamorelinRefillSystemicQuestions = [
  {
    field: 'mdiTesamorelinRefillSystemic_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiTesamorelinRefillSystemic_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field:
      'mdiTesamorelinRefillSystemic_pregnantBreastfeedingPlanningPregnancy',
    label: 'Are you currently pregnant, breastfeeding, or planning pregnancy?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'NO' },
        { key: 'yes_one_of_these', value: 'Yes, one of these' }
      ]
    },
    extras: { mdiQuestionId: 'aa9d0ffd-6073-461a-958d-f54a6d66e85f' }
  },
  {
    field: 'mdiTesamorelinRefillSystemic_sinceLastRefillProblemsHaving',
    label: 'Since your last refill, please select any problems you are having.',
    type: 'select',
    educationalSlide:
      'This question is required to evaluate your health and how you are responding to the medication. Most patients tolerate this medication very well. However, we need to be sure.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'none_things_are_going_well',
          value: 'NONE, things are going well'
        },
        { key: 'joint_or_hand_swelling', value: 'Joint or hand swelling' },
        {
          key: 'tingling_numbness_or_joint_pain',
          value: 'Tingling, numbness, or joint pain'
        },
        {
          key: 'nausea_flushing_in_the_face',
          value: 'Nausea, flushing in the face'
        },
        {
          key: 'headaches_dizziness_or_severe_fatigue',
          value: 'Headaches, dizziness, or severe fatigue'
        },
        { key: 'severe_upset_stomach', value: 'Severe upset stomach' },
        {
          key: 'major_problems_with_sleep',
          value: 'Major problems with sleep'
        },
        {
          key: 'pain_redness_or_swelling_at_the_injectio',
          value: 'Pain, redness, or swelling at the injection site'
        },
        {
          key: 'changes_in_glucose_levels_or_a1c_if_know',
          value: 'Changes in glucose levels or A1C (if known)'
        },
        {
          key: 'more_than_one_of_these_problems',
          value: 'MORE than one of these problems'
        }
      ]
    },
    extras: { mdiQuestionId: '29cb4b7b-95e8-4784-ab61-1b82a503a2ac' }
  },
  {
    field: 'mdiTesamorelinRefillSystemic_labsCompletedWhileMedication',
    label: 'Have you had your labs completed while on this medication?',
    type: 'file_upload',
    subLabel:
      'Please upload recent labs if you have them (within the last 6 months).\nIGF-1, LC/MS (16293)\nHemoglobin A1c (496)\nLipid Panel (7600)\nCMP (10231)\nTSH (899)\nFree T4 (866)',
    accepts: [
      'image/jpeg',
      'image/jpg',
      'image/webp',
      'image/png',
      'application/pdf'
    ],
    answer: [
      {
        resourceId: 'mdiTesamorelinRefillSystemic_labsCompletedWhileMedication',
        buttonLabel: 'Upload',
        required: false
      }
    ],
    required: false,
    extras: { mdiQuestionId: '6d58f864-bc24-42ab-aefd-373b2d069b7c' }
  },
  {
    field: 'mdiTesamorelinRefillSystemic_updateMessageDoctor',
    label: 'This is your update message to your doctor.',
    type: 'info',
    subLabel:
      'Please introduce yourself and give any other information about yourself and your health that you would like to.',
    answer: {
      type: 'text',
      name: 'mdiTesamorelinRefillSystemic_updateMessageDoctor',
      placeholder:
        'Example: "Hi doctor, other than what I already answered I am otherwise healthy and excited to get started."'
    },
    extras: { mdiQuestionId: 'f3561911-1119-4b9e-8dc9-f7574ea6fc23' }
  },
  {
    field:
      'mdiTesamorelinRefillSystemic_duePregancyPlanningBreastfeedingStatus',
    label:
      'Due to pregancy planning or breastfeeding status, it is unsafe for you to take this medication.',
    type: 'info',
    subLabel: 'Please contact [customer_support_email] for safe alternatives.',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: 'd98bd14a-5d67-4641-95c5-6562a266cda9',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiTesamorelinRefillSystemic_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiTesamorelinRefillSystemicAnswerField = Partial<
  QuestionAnswerMap<typeof mdiTesamorelinRefillSystemicQuestions>
>;

export default mdiTesamorelinRefillSystemicQuestions;
